import React from "react"
import "./frames.css"

const Diseno = () => {
  return (
    <div className="frames-container">
      <h1 className="frames-title">Diseño</h1>
      <h2 className="frames-subtitle">Emplazamiento y Diseño de Interiores</h2>
      <p className="frames-text">
        Una vez seleccionado el centro para implantar la Unidad de Medicina
        Hiperbárica, es crucial determinar el espacio ideal de la instalación.
        Hay que considerar factores como la altura del piso, cercanía a la
        fuente de Oxígeno, vestuarios, recepción y más. Además, la previsión de
        crecimiento y las medidas de seguridad son aspectos esenciales. Con toda
        esta información, te asesoramos en el diseño de la barosala para que sea
        cómoda y operativa para pacientes y técnicos.
      </p>
    </div>
  )
}

export default Diseno
